import {
  StateAidCertificateType,
  type TStateAidFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/types.ts';

export const STATE_AID_CERTIFICATE_TYPE_OPTIONS = [
  {
    value: StateAidCertificateType.Credit,
    label: 'Доступні кредити 5-7-9%',
    description: 'Довідка для програми «Доступні кредити 5-7-9%».',
  },
  {
    value: StateAidCertificateType.Leasing,
    label: 'Доступний фінансовий лізинг 5-7-9%',
    description: 'Довідка для програми «Доступний фінансовий лізинг 5-7-9%».',
  },
] as const;

export const STATE_AID_CERTIFICATE_CONFIG = {
  [StateAidCertificateType.Credit]: {
    certificateType: 'MMSP_STATE_AID_RECEIVED',
    endpoint: 'mmsp-state-aid-received',
    title: 'Довідка про суми отриманої ММСП державної допомоги',
    programName: 'Доступні кредити 5-7-9%',
    includesCovidSection: true,
  },
  [StateAidCertificateType.Leasing]: {
    certificateType: 'STATE_AID_RECEIVED',
    endpoint: 'state-aid-received',
    title: 'Довідка про суми отриманої ММСП державної допомоги',
    programName: 'Доступний фінансовий лізинг 5-7-9%',
    includesCovidSection: false,
  },
} as const;

export const STATE_AID_RECEIVED_ROWS = [
  {
    label: 'Сума отриманої державної допомоги, грн.',
    mmsp: 'amountMmsp',
    group: 'amountGroup',
    numeric: true,
  },
  { label: 'Дата (період) отримання державної допомоги', mmsp: 'periodMmsp', group: 'periodGroup' },
  {
    label: 'Найменування установи/організації, через яку отримано державну допомогу',
    mmsp: 'institutionMmsp',
    group: 'institutionGroup',
  },
] as const;

export const STATE_AID_APPROVED_ROWS = [
  {
    label: 'Сума планової державної допомоги до отримання, грн.',
    mmsp: 'AmountMmsp',
    group: 'AmountGroup',
    numeric: true,
  },
  {
    label: 'Дата подання заявки на отримання державної допомоги',
    mmsp: 'ApplicationDateMmsp',
    group: 'ApplicationDateGroup',
  },
  {
    label: 'Дата затвердження заявки на отримання державної допомоги',
    mmsp: 'ApprovalDateMmsp',
    group: 'ApprovalDateGroup',
  },
  {
    label: 'Дата (період) планового отримання державної допомоги',
    mmsp: 'PlannedPeriodMmsp',
    group: 'PlannedPeriodGroup',
  },
  {
    label: 'Установа/організація, яка затвердила заявку',
    mmsp: 'InstitutionMmsp',
    group: 'InstitutionGroup',
  },
] as const;

export const STATE_AID_REQUESTED_ROWS = [
  {
    label: 'Сума запитуваної державної допомоги, грн.',
    mmsp: 'AmountMmsp',
    group: 'AmountGroup',
    numeric: true,
  },
  {
    label: 'Дата подання заявки на отримання державної допомоги',
    mmsp: 'ApplicationDateMmsp',
    group: 'ApplicationDateGroup',
  },
  {
    label: 'Установа/організація, до якої подано заявку',
    mmsp: 'InstitutionMmsp',
    group: 'InstitutionGroup',
  },
] as const;

export const STATE_AID_BOOLEAN_FIELDS: ReadonlyArray<{
  name: keyof TStateAidFormValues;
  label: string;
}> = [
  {
    name: 'exportSales',
    label: 'Здійснює продаж товарів іноземним суб’єктам господарської діяльності',
  },
  { name: 'idpStatus', label: 'Наявність статусу внутрішньо переміщеної особи (ВПО)' },
  { name: 'veteranStatus', label: 'Наявність статусу ветерана війни' },
  { name: 'disabilityStatus', label: 'Наявність статусу особи з інвалідністю' },
  { name: 'agricultural', label: 'Є сільськогосподарським товаровиробником' },
];
